export function resolvePortalScope(user, clients = []) {
  const person = user?.person_id || null;
  const company = user?.company_id || null;
  const enterprise = user?.enterprise_id || null;
  const email = String(user?.email || '').trim().toLowerCase();
  const clientIds = new Set();
  for (const client of clients) {
    if (person && client.person_id === person) clientIds.add(client.id);
    if (company && client.company_id === company) clientIds.add(client.id);
    if (email && String(client.email || '').toLowerCase() === email) clientIds.add(client.id);
  }
  const linked = Boolean(person || company || enterprise || clientIds.size);
  return { person, company, enterprise, clientIds, linked };
}

export function isOwnedEnterprise(row, user) {
  if (!row) return false;
  if (user?.enterprise_id && String(row.id) === String(user.enterprise_id)) return true;
  if (user?.company_id && String(row.company_id || '') === String(user.company_id)) return true;
  if (user?.person_id && String(row.owner_person_id || '') === String(user.person_id)) return true;
  return false;
}

export function isPortalOwned(row, scope) {
  if (!scope?.linked) return false;
  const req = row?.requerente_id;
  const emp = row?.empreendimento_id;
  return Boolean(
    (scope.person && req === scope.person) ||
      (scope.company && req === scope.company) ||
      (scope.enterprise && emp === scope.enterprise) ||
      (req && scope.clientIds.has(req))
  );
}
